export var EditorEventSource;
(function (EditorEventSource) {
    EditorEventSource[EditorEventSource["UserInteraction"] = 0] = "UserInteraction";
    EditorEventSource[EditorEventSource["Script"] = 1] = "Script";
})(EditorEventSource || (EditorEventSource = {}));
